var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"disable-time-invoices-list"},[_c('draggable-dynamic-table',{ref:"disableTimeInvoicesList",attrs:{"options":_vm.options,"columns":_vm.columnsLabel,"data":_vm.data,"in-modal":true,"zero-top-radius":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }